import { render } from "./ImgDevice.vue?vue&type=template&id=ca7faa5e&scoped=true"
import script from "./ImgDevice.vue?vue&type=script&lang=js"
export * from "./ImgDevice.vue?vue&type=script&lang=js"

import "./ImgDevice.vue?vue&type=style&index=0&id=ca7faa5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca7faa5e"]])

export default __exports__